var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-base"},_vm._l((_vm.titles),function(item){return _c('div',{key:item.type,staticClass:"item",on:{"click":function($event){return _vm.onClickItem(item)}}},[_vm._v(_vm._s(item.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }